module.exports = {"data":{"markdownRemark":{"html":"<p>The book is wonderful and brought back many memories. We visited many times when it was all being built and then up and running.</p>","frontmatter":{"path":"/content/many-memories","year":"1990-1999","title":"Many memories","image":null,"imagetitle":null,"author":"Emma (Ashley) Shuckburgh","publication":null}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/content-many-memories.json
// module id = 365
// module chunks = 53955099886861